import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Avatar from "@mui/material/Avatar"
import Popover from "@mui/material/Popover"
import GroupsIcon from "@mui/icons-material/Groups"
import { MONO, CHAT_COLOR } from "../constants"

export function ForwardPicker({ anchorPosition, openChats, groups, profiles, onPick, onClose }) {
  const open = Boolean(anchorPosition)
  return (
    <Popover data-chat-overlay="true" open={open} anchorReference="anchorPosition"
      anchorPosition={anchorPosition} onClose={onClose}
      transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      PaperProps={{ "data-chat-overlay": "true", sx: { backgroundColor: "var(--app-paper)",
        border: "1px solid rgba(245,158,11,0.22)", borderRadius: "8px", p: 0.5,
        minWidth: 160, maxHeight: 240, overflowY: "auto" } }}>
      <Typography sx={{ fontFamily: MONO, fontSize: "0.58rem", color: "rgba(var(--app-fg-rgb),0.35)", px: 1, py: 0.4 }}>
        Forward to…
      </Typography>
      <Box onClick={() => onPick("global")}
        sx={{ px: 1, py: 0.5, cursor: "pointer", borderRadius: "4px",
          fontFamily: MONO, fontSize: "0.68rem", color: CHAT_COLOR,
          "&:hover": { backgroundColor: "rgba(245,158,11,0.08)" } }}>
        # Global
      </Box>
      {openChats.map(u => (
        <Box key={u} onClick={() => onPick(u)}
          sx={{ display: "flex", alignItems: "center", gap: 0.6, px: 1, py: 0.5, cursor: "pointer", borderRadius: "4px",
            "&:hover": { backgroundColor: "rgba(var(--app-fg-rgb),0.06)" } }}>
          {profiles?.[u]?.avatar_b64
            ? <Avatar src={profiles[u].avatar_b64} sx={{ width: 16, height: 16 }} />
            : <Avatar sx={{ width: 16, height: 16, fontSize: 8, bgcolor: "rgba(var(--app-fg-rgb),0.08)" }}>
                {(profiles?.[u]?.display_name ?? u)[0]?.toUpperCase()}
              </Avatar>}
          <Typography sx={{ fontFamily: MONO, fontSize: "0.68rem", color: "rgba(var(--app-fg-rgb),0.8)" }}>
            {profiles?.[u]?.display_name ?? u}
          </Typography>
        </Box>
      ))}
      {groups.map(g => (
        <Box key={g.group_id} onClick={() => onPick("group:" + g.group_id)}
          sx={{ display: "flex", alignItems: "center", gap: 0.6, px: 1, py: 0.5, cursor: "pointer", borderRadius: "4px",
            "&:hover": { backgroundColor: "rgba(var(--app-fg-rgb),0.06)" } }}>
          {g.image
            ? <Avatar src={g.image} sx={{ width: 16, height: 16 }} />
            : <Avatar sx={{ width: 16, height: 16, bgcolor: "rgba(var(--app-fg-rgb),0.08)" }}>
                <GroupsIcon sx={{ fontSize: 10 }} />
              </Avatar>}
          <Typography sx={{ fontFamily: MONO, fontSize: "0.68rem", color: "rgba(var(--app-fg-rgb),0.8)" }}>
            {g.name}
          </Typography>
        </Box>
      ))}
      {openChats.length === 0 && groups.length === 0 && (
        <Typography sx={{ fontFamily: MONO, fontSize: "0.6rem", color: "rgba(var(--app-fg-rgb),0.25)", px: 1, py: 0.5 }}>
          No other open chats.
        </Typography>
      )}
    </Popover>
  )
}
